module.exports = __webpack_public_path__ + "img/SuperOKBoom-WhiteBlack.f6a2120c.png";